/**
 * The official Weever theme warning color hex code.
 */
export const warningColor = '#FD9A18';

/**
* The relevant CSS class names and ids used in the sidebar.
*/
export const SIDEBAR_CLASS = {
    nav: 'sidebar-navigation',
    menu: 'c-sidebar__menu',
    title: 'c-sidebar__title',
    list: 'c-sidebar__list',
    listv: 'c-sidebar__list--vertical',
    item: 'c-sidebar__item',
    link: 'c-sidebar__link',
    icon: 'c-sidebar__icon',
    errorMessage: 'c-sidebar__error-message',
    progressLoader: 'c-progress-loader',
    progressLoaderIndeterminate: 'c-progress-loader__indeterminate',
    progressLoaderId: 'sidenavigation-progress-loader',
    rootId: `#single-spa-application\\:sidebar`
 };

/**
 * Performs a modulus-based operation on a string of characters
 * to make a pseudo-random selection of a background color for
 * a user's avatar.
 * @param {string} str The string of characters (e.g. a user's initials)
 * @returns {string} The hex code of the chosen background color
 */
export const getUserAvatarBackgroundColor = (str) => {
    // this needs to be kept in sync with profilePhoto.js in wxPortal
    const stringToColor = (string, saturation = 100, lightness = 30) => {
        let hash = 0;
        for (let i = 0; i < string.length; i++) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
            hash &= hash;
        }
        return `hsl(${(hash % 360)}, ${saturation}%, ${lightness}%)`;
    };

    return stringToColor(str);
};

/**
 * Modifies a given profile photo URL to redirect through our image processing service.
 * @param {string} originalUrl The URL to the profile photo.
 * @param {int} size The length and width of the final desired resolution, in pixels.
 * @returns A URL that points to our image processing service with query parameters
 * for transformation (e.g. size, object recognition, file format, etc.).
 */
export const getUserAvatarProcessingUrl = (originalUrl, size = 40) => {
    const pathRegex = /.+\/(.*)\.com\/(.*)/g;
    const [, bucket, path] = pathRegex.exec(originalUrl);
    const url = `https://res.cloudinary.com/weeverapps/image/upload/`;
    const transformations = `c_thumb,f_auto,g_face:center,h_${size},w_${size},q_auto:good`;
    return `${url}${transformations}/${bucket}/${path}`;
};
